import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-grid-page',
  templateUrl: './shop-grid-page.component.html',
  styleUrls: ['./shop-grid-page.component.scss']
})
export class ShopGridPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
